import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeCopy" })
class CopyStore extends VuexModule {
  pastesoap = {};
  pastediagnosa = [];
  pastelab = [];
  pastero = [];
  copyLab = "0";
  copyRo = "0";
  copySoap = "0";
  copySoapInstant = false;
  copyDiagnosa = "0";
  copyDiagnosaInstant = false;
  copyResep = "0";
  copyResepInstant = false;
  pasteresep = {};
  copyS = "0";
  copyA = "0";
  copyP = "0";
  copyInst = "0";
  subj = "";
  ass = "";
  plan = "";
  inst = "";
  soapInstantSave = false;

  // Salin dari side-panel Riwayat Pasien (Poin 3): payload berisi target field
  // (status_lokalis / penunjang / keluhan / riwayat_penyakit / tindakan) dan
  // value. Komponen target (CardAssesmenDokter, Lokalis) watch dan auto-fill.
  // Pakai counter agar watch trigger walau value sama.
  pastePemeriksaanFisik: {
    target: string;
    value: string;
    seq: number;
  } | null = null;

  @Mutation SET_PASTE_SOAP(soap: object) {
    this.pastesoap = soap;
  }

  @Mutation SET_PASTE_DIAGNOSA(diagnosa: Array<object>) {
    this.pastediagnosa = [
      ...new Map(diagnosa.map(item => [item["kode"], item])).values()
    ];
  }

  @Mutation SET_PASTE_LAB(lab: Array<object>) {
    this.pastelab = lab;
  }

  @Mutation SET_PASTE_RO(ro: Array<object>) {
    this.pastero = ro;
  }

  @Mutation SET_COPY_SOAP(copySoap: string) {
    this.copySoap = copySoap;
  }

  @Mutation SET_COPY_SOAP_INSTAN(isInstant: boolean) {
    this.copySoapInstant = isInstant;
  }

  @Mutation SET_COPY_DIAGNOSA(copyDiagnosa: string) {
    this.copyDiagnosa = copyDiagnosa;
  }

  @Mutation SET_COPY_DIAGNOSA_INSTAN(isInstant: boolean) {
    this.copyDiagnosaInstant = isInstant;
  }

  @Mutation SET_COPY_RESEP(copyResep: string) {
    this.copyResep = copyResep;
  }

  @Mutation SET_COPY_RESEP_INSTAN(isInstant: boolean) {
    this.copyResepInstant = isInstant;
  }

  @Mutation SET_PASTE_RESEP(pasteresep: string) {
    this.pasteresep = pasteresep;
  }
  @Mutation SET_COPY_LAB(copyLab: string) {
    this.copyLab = copyLab;
  }

  @Mutation SET_COPY_RO(copyRo: string) {
    this.copyRo = copyRo;
  }

  @Mutation SET_COPY_SUBJ(copyS: string) {
    this.copyS = copyS;
  }

  @Mutation SET_COPY_ASS(copyA: string) {
    this.copyA = copyA;
  }

  @Mutation SET_COPY_PLAN(copyP: string) {
    this.copyP = copyP;
  }

  @Mutation SET_COPY_INST(copyInst: string) {
    this.copyInst = copyInst;
  }

  @Mutation SET_PASTE_SUBJ(subj: string) {
    this.subj = subj;
  }

  @Mutation SET_PASTE_ASS(ass: string) {
    this.ass = ass;
  }

  @Mutation SET_PASTE_PLAN(plan: string) {
    this.plan = plan;
  }

  @Mutation SET_PASTE_INST(inst: string) {
    this.inst = inst;
  }

  @Mutation SET_SOAP_INSTANT_SAVE(val: boolean) {
    this.soapInstantSave = val;
  }

  @Action act_copy_soap(val) {
    const data = {
      s: val["s"],
      o: val["o"],
      a: val["a"],
      p: val["p"],
      instruksi: val["instruksi"]
    };
    this.SET_PASTE_SOAP(data);
    this.SET_COPY_SOAP("1");
    this.SET_PASTE_SUBJ(val["s"]);
    this.SET_PASTE_ASS(val["a"]);
    this.SET_PASTE_PLAN(val["p"]);
    this.SET_PASTE_INST(val["instruksi"]);
    this.SET_COPY_SUBJ("1");
    this.SET_COPY_ASS("1");
    this.SET_COPY_PLAN("1");
    this.SET_COPY_INST("1");
  }

  @Action act_copy_soap_instant(val) {
    this.act_copy_soap(val);
    this.SET_COPY_SOAP_INSTAN(true);
  }

  @Action act_copy_diagnosa(val) {
    this.SET_PASTE_DIAGNOSA(val);
    this.SET_COPY_DIAGNOSA("1");
  }

  @Action act_copy_diagnosa_instant(val) {
    this.act_copy_diagnosa(val);
    this.SET_COPY_DIAGNOSA_INSTAN(true);
  }

  @Action act_copy_lab(val) {
    this.SET_PASTE_LAB(val);
    this.SET_COPY_LAB("1");
  }

  @Action act_copy_ro(val) {
    this.SET_PASTE_RO(val);
    this.SET_COPY_RO("1");
  }

  @Action clear_copy_all() {
    this.SET_COPY_SOAP("0");
    this.SET_COPY_SOAP_INSTAN(false);
    this.SET_SOAP_INSTANT_SAVE(false);
    this.SET_COPY_DIAGNOSA("0");
    this.SET_COPY_DIAGNOSA_INSTAN(false);
    this.SET_COPY_RESEP("0");
    this.SET_COPY_RESEP_INSTAN(false);
    this.SET_COPY_LAB("0");
    this.SET_COPY_RO("0");
    this.SET_PASTE_SOAP({});
    this.SET_PASTE_DIAGNOSA([]);
    this.SET_PASTE_LAB([]);
    this.SET_PASTE_RO([]);
    this.SET_PASTE_RESEP("");
    this.SET_COPY_SUBJ("0");
    this.SET_PASTE_SUBJ("");
    this.SET_COPY_ASS("0");
    this.SET_PASTE_ASS("");
    this.SET_COPY_PLAN("0");
    this.SET_PASTE_PLAN("");
    this.SET_COPY_INST("0");
    this.SET_PASTE_INST("");
  }

  @Action act_copy_resep(val) {
    this.SET_PASTE_RESEP(val);
    this.SET_COPY_RESEP("1");
  }

  @Action act_copy_resep_instant(val) {
    this.act_copy_resep(val);
    this.SET_COPY_RESEP_INSTAN(true);
  }

  @Action clear_copy_diagnosa() {
    this.SET_COPY_DIAGNOSA("0");
    this.SET_COPY_DIAGNOSA_INSTAN(false);
    this.SET_PASTE_DIAGNOSA([]);
  }

  @Action clear_copy_soap() {
    this.SET_COPY_SOAP("0");
    this.SET_SOAP_INSTANT_SAVE(false);

    setTimeout(() => {
      this.SET_COPY_SOAP_INSTAN(false);
      this.SET_PASTE_SOAP({});
    }, 1000);
  }

  @Action act_soap_instant_save() {
    this.SET_SOAP_INSTANT_SAVE(true);
  }

  @Action clear_copy_lab() {
    this.SET_COPY_LAB("0");
    this.SET_PASTE_LAB([]);
  }

  @Action clear_copy_ro() {
    this.SET_COPY_RO("0");
    this.SET_PASTE_RO([]);
  }

  @Action clear_copy_resep() {
    this.SET_COPY_RESEP("0");
    this.SET_COPY_RESEP_INSTAN(false);
    this.SET_PASTE_RESEP("");
  }

  @Action clear_copy_subj() {
    this.SET_COPY_SUBJ("0");
    this.SET_PASTE_SUBJ("");
  }

  @Action clear_copy_ass() {
    this.SET_COPY_ASS("0");
    this.SET_PASTE_ASS("");
  }

  @Action clear_copy_plan() {
    this.SET_COPY_PLAN("0");
    this.SET_PASTE_PLAN("");
  }

  @Action clear_copy_instruksi() {
    this.SET_COPY_INST("0");
    this.SET_PASTE_INST("");
  }

  @Mutation SET_PASTE_PEMERIKSAAN_FISIK(
    payload: { target: string; value: string } | null
  ) {
    if (payload) {
      const prevSeq = this.pastePemeriksaanFisik
        ? this.pastePemeriksaanFisik.seq
        : 0;
      this.pastePemeriksaanFisik = {
        target: payload.target,
        value: payload.value,
        seq: prevSeq + 1
      };
    } else {
      this.pastePemeriksaanFisik = null;
    }
  }

  @Action act_paste_pemeriksaan_fisik(payload: {
    target: string;
    value: string;
  }) {
    this.SET_PASTE_PEMERIKSAAN_FISIK(payload);
  }

  @Action clear_paste_pemeriksaan_fisik() {
    this.SET_PASTE_PEMERIKSAAN_FISIK(null);
  }
}

export const storeCopy = getModule(CopyStore);
